"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.termsAndConditionsVersion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var markdown_to_jsx_1 = __importDefault(require("markdown-to-jsx"));
var Main_1 = __importDefault(require("components/Layout/Main"));
var TermsAndConditions_md_1 = __importDefault(require("raw-loader!./TermsAndConditions.md"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var HudledHelmet_1 = __importDefault(require("../HudledHelmet"));
var Banner_1 = __importDefault(require("./styles/Banner"));
// Please remember to change this number as you change the Terms and Conditions content
exports.termsAndConditionsVersion = end2end_1.termsAndConditionsVersion;
var TermsAndConditions = function () { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Terms and conditions", description: "Hudled's terms and conditions" }), (0, jsx_runtime_1.jsx)(Main_1.default, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ p: 8 }, { children: [(0, jsx_runtime_1.jsx)(Banner_1.default, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Terms and conditions" })) }), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: ["Version number: ", exports.termsAndConditionsVersion] })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Last updated: 23rd January 2023" })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 2 }, { children: (0, jsx_runtime_1.jsx)(markdown_to_jsx_1.default, { children: TermsAndConditions_md_1.default }) }))] })) })] })); };
exports.default = TermsAndConditions;
